
const lockedReducer = (state: any, action: any) => {
    let returnActions = action
    if (typeof action === "function") {
        returnActions = action(state); // Call the function with the current state
    }
    return { ...state, ...Object.fromEntries(Object.entries(returnActions).filter(([key])=> key in state)) };
};

export default lockedReducer